// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subpage-title {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-top: 20px;
    padding-bottom: 10px;
    color: var(--psblue);
}
table {
    border-collapse: collapse;
}
.table-wrapper{
    margin: 10px 3% 3%;
}

.fl-table {
    font-size: 12px;
    font-weight: normal;
    border: none;
    width: 100%;
    white-space: nowrap;
    background-color: white;
    table-layout:fixed;
    box-shadow: 0px 35px 50px rgba( 0, 0, 0, 0.2 );
}

.valuations-table td, .valuations-table th {
    text-align: center;
    padding: 8px;
    width: auto;
    overflow: scroll;
}

.valuations-table th:nth-child(3){
    width: 50%;
}

.fl-table td {
    border-right: 1px solid #f8f8f8;
    font-size: 16px;
    cursor: pointer;
}

.fl-table thead th {
    color: #ffffff;
    background: var(--psyellow);
}


.fl-table thead th:nth-child(odd) {
    color: #ffffff;
    background: var(--psblue);
}

.fl-table tr:nth-child(even) {
    background: #F8F8F8;
}
td:nth-child(5) {
    padding: 0;
}
.delete-row-button {
    height: 35px;
    margin: 0;
    padding: 0;
    width: 100%;
    cursor: pointer;
    border: none;
    background: none;
}
.fl-table tr:hover{
    background: #F2F2F2;
}

#formSearchbox {
    width: 100%;
    font-size: 24px;
    cursor: text;
    padding: 10px;
    height: 50px;
    border: none;
    position: sticky; 
    top: 0; 
}
#formSearchbox:focus {
    outline: none;
}

.fl-table thead { 
    position: sticky; 
    top: 50px; 
}
.row-delete-icon {
    visibility: hidden;
    cursor: pointer;
}
tr:hover .row-delete-icon {
    visibility: visible;
}
button:disabled, button:disabled > * {
    cursor: not-allowed
}`, "",{"version":3,"sources":["webpack://./src/table/table.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,oBAAoB;IACpB,oBAAoB;AACxB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;;AAGA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,YAAY;IACZ,SAAS;IACT,UAAU;IACV,WAAW;IACX,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,MAAM;AACV;AACA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,mBAAmB;AACvB;AACA;IACI;AACJ","sourcesContent":[".subpage-title {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    padding-top: 20px;\n    padding-bottom: 10px;\n    color: var(--psblue);\n}\ntable {\n    border-collapse: collapse;\n}\n.table-wrapper{\n    margin: 10px 3% 3%;\n}\n\n.fl-table {\n    font-size: 12px;\n    font-weight: normal;\n    border: none;\n    width: 100%;\n    white-space: nowrap;\n    background-color: white;\n    table-layout:fixed;\n    box-shadow: 0px 35px 50px rgba( 0, 0, 0, 0.2 );\n}\n\n.valuations-table td, .valuations-table th {\n    text-align: center;\n    padding: 8px;\n    width: auto;\n    overflow: scroll;\n}\n\n.valuations-table th:nth-child(3){\n    width: 50%;\n}\n\n.fl-table td {\n    border-right: 1px solid #f8f8f8;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n.fl-table thead th {\n    color: #ffffff;\n    background: var(--psyellow);\n}\n\n\n.fl-table thead th:nth-child(odd) {\n    color: #ffffff;\n    background: var(--psblue);\n}\n\n.fl-table tr:nth-child(even) {\n    background: #F8F8F8;\n}\ntd:nth-child(5) {\n    padding: 0;\n}\n.delete-row-button {\n    height: 35px;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    cursor: pointer;\n    border: none;\n    background: none;\n}\n.fl-table tr:hover{\n    background: #F2F2F2;\n}\n\n#formSearchbox {\n    width: 100%;\n    font-size: 24px;\n    cursor: text;\n    padding: 10px;\n    height: 50px;\n    border: none;\n    position: sticky; \n    top: 0; \n}\n#formSearchbox:focus {\n    outline: none;\n}\n\n.fl-table thead { \n    position: sticky; \n    top: 50px; \n}\n.row-delete-icon {\n    visibility: hidden;\n    cursor: pointer;\n}\ntr:hover .row-delete-icon {\n    visibility: visible;\n}\nbutton:disabled, button:disabled > * {\n    cursor: not-allowed\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
